import ReactGA from 'react-ga4';
import { applyFilter } from '@/redux/slices/dataTableSlice';
import { Middleware } from '@reduxjs/toolkit';

const analyticsMiddleware: Middleware = () => next => (action: any) => {
  if (action.type === applyFilter.type) {
    ReactGA.event('filter_used', {
      event_category: 'Filter',
      event_label: action?.payload?.type
    });
  }
  return next(action);
};

export default analyticsMiddleware;